import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbCardModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { CommissionsModalComponent } from './commissions-modal.component';

@NgModule({
	imports: [
		CommonModule,
		NbCardModule,
		FormsModule,
	],
	declarations: [
		CommissionsModalComponent,
	],
	entryComponents: [
		CommissionsModalComponent
	]
})

export class CommissionsModalModule { }


// WEBPACK FOOTER //
// ./src/app/pages/commissions/modal/commissions-modal.module.ts